import React, { FC, memo } from 'react';
import { Box, Drawer } from '@mui/material';
import { NotificationDrawerProps } from './types';

const NotificationDrawer: FC<NotificationDrawerProps> = ({ width, children = '', open, handleClose }) => {
  return (
    <Box>
      <Drawer
        transitionDuration={500}
        slotProps={{
          backdrop: {
            style: {
              backgroundColor: '#000',
              opacity: 0.8,
            },
          },
        }}
        anchor={'right'}
        variant='temporary'
        open={open}
        onClose={handleClose}
        sx={{
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width},
          zIndex: 1000,
        }}
      >
        <Box sx={{ p: 2, textAlign: 'center', padding:'30px' }}>{children}</Box>
      </Drawer>
    </Box>
  );
};

export default memo(NotificationDrawer);
